import { Instance, types } from 'mobx-state-tree';
import { ComponentField } from '../../../../infrastructure/dynamic-forms/ComponentField';

export const AddressRow = types.model('AddressRow', {
  formFields: types.array(ComponentField)
});
export type AddressRow = Instance<typeof AddressRow>;
